import Dialog, {
  DialogProps,
} from '$tablet-app/src/app/components/Dialog/Dialog';
import { Goal } from '@akin-home/goals';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';
import GoalLibraryCard from '../GoalLibraryCard';

interface Props extends DialogProps {
  goals?: Goal[];
  onPressSuggestion?(goal: Goal): void;
}

export const GoalSuggestionDialog = ({
  goals,
  onPressSuggestion,
  ...props
}: Props) => (
  <Dialog size="xl" {...props}>
    <PaddingContainer>
      <Text variant="h2" weight="semibold">
        Suggestions
      </Text>
    </PaddingContainer>

    <ScrollView>
      <ListContainer>
        {goals?.map((goal) => (
          <Card key={goal.id} goal={goal} onPress={onPressSuggestion} />
        ))}
      </ListContainer>
    </ScrollView>
  </Dialog>
);

const PaddingContainer = styled.View`
  padding: 50px 50px 30px;
`;

const ScrollView = styled.ScrollView``;

const ListContainer = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  padding: 0 50px 50px;
  justify-content: center;
`;

const Card = styled(GoalLibraryCard)`
  min-width: 29%;
  max-width: 100%;
  flex-wrap: wrap;
`;
